import { render, staticRenderFns } from "./HaberTanimla.vue?vue&type=template&id=53999839&scoped=true&"
import script from "./HaberTanimla.vue?vue&type=script&lang=js&"
export * from "./HaberTanimla.vue?vue&type=script&lang=js&"
import style0 from "./HaberTanimla.vue?vue&type=style&index=0&id=53999839&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53999839",
  null
  
)

export default component.exports